import React from "react";
import { Facebook, Instagram, MessageCircle } from "lucide-react";

interface SocialLinksProps {
  facebook?: string | null;
  instagram?: string | null;
  whatsapp?: string | null;
  name?: string | null;
  className?: string;
  variant?: "default" | "header";
}

function normalizeUrl(value?: string | null, base?: string): string | undefined {
  if (!value) return undefined;
  const v = value.trim();
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  if (base) return `https://${base}/${v.replace(/^@/, "")}`;
  return v;
}

export const RestaurantSocialLinks: React.FC<SocialLinksProps> = ({
  facebook,
  instagram,
  whatsapp,
  name,
  className = "",
  variant = "default",
}) => {
  const fb = normalizeUrl(facebook, "facebook.com");
  const ig = normalizeUrl(instagram, "instagram.com");
  const wa = whatsapp ? `https://wa.me/${whatsapp.replace(/\D/g, "")}` : undefined;

  if (!fb && !ig && !wa) return null;

  const linkClass = variant === "header"
    ? "border-background/40 bg-background/90 text-foreground shadow-sm hover:bg-background"
    : "border-border bg-card text-foreground hover:bg-muted";

  return (
    <div className={`flex flex-nowrap gap-2 sm:flex-wrap md:gap-3 ${className}`} aria-label={`Redes sociales de ${name || "restaurante"}`}>
      {fb && (
        <a
          href={fb}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir Facebook"
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center gap-2 rounded-full border p-0 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:h-auto sm:w-auto sm:min-h-[44px] sm:min-w-[44px] sm:px-3 sm:py-2 ${linkClass}`}
          title="Facebook"
        >
          <Facebook className="h-4 w-4" />
          <span className="hidden sm:inline">Facebook</span>
        </a>
      )}
      {ig && (
        <a
          href={ig}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir Instagram"
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center gap-2 rounded-full border p-0 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:h-auto sm:w-auto sm:min-h-[44px] sm:min-w-[44px] sm:px-3 sm:py-2 ${linkClass}`}
          title="Instagram"
        >
          <Instagram className="h-4 w-4" />
          <span className="hidden sm:inline">Instagram</span>
        </a>
      )}
      {wa && (
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir WhatsApp"
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center gap-2 rounded-full border p-0 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:h-auto sm:w-auto sm:min-h-[44px] sm:min-w-[44px] sm:px-3 sm:py-2 ${linkClass}`}
          title="WhatsApp"
        >
          <MessageCircle className="h-4 w-4" />
          <span className="hidden sm:inline">WhatsApp</span>
        </a>
      )}
    </div>
  );
};

export default RestaurantSocialLinks;
